var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:_vm.mainClass,style:(_vm.mainStyle)},[_vm._t("leftText"),_vm._v(" "),_c('span',{class:_vm.countClass,style:(_vm.countStyle)},[_c('span',{attrs:{"id":_vm.countId}},[_vm._v(_vm._s(_vm.initCount))]),_c('span',[_vm._v(_vm._s(_vm.unitText))])]),_vm._v(" "),_vm._t("rightText")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }